import { EventRow } from "api/event";
import { EventAppsRow } from "api/event-apps";
import { GetUserById } from "api/profile";
import { VoteByEventId } from "api/vote";
import { StateCreator } from "zustand";

export const SECRET_SANTA_TAB = {
  "my-pair": 0,
  "my-wishlist": 1,
} as const;

export type SecretSantaTabKey = keyof typeof SECRET_SANTA_TAB;
export type SecretSantaTabValue = (typeof SECRET_SANTA_TAB)[SecretSantaTabKey];

export const MONEY_MANAGER_TAB = {
  setup: 0,
  "data-entry": 1,
  summary: 2,
} as const;

export type MoneyManagerTabKey = keyof typeof MONEY_MANAGER_TAB;
export type MoneyManagerTabValue = (typeof MONEY_MANAGER_TAB)[MoneyManagerTabKey];

export const ROOM_MANAGER_TAB = {
  setup: 0,
  rooms: 1,
} as const;

export type RoomManagerTabKey = keyof typeof ROOM_MANAGER_TAB;
export type RoomManagerTabValue = (typeof ROOM_MANAGER_TAB)[RoomManagerTabKey];

export interface SelectedSlice {
  selected: {
    eventApps: EventAppsRow["active_apps"] | null;
    eventId: number | null;
    moneyManagerTab: number;
    groupId: number | null;
    groupInviteLink: string | null;
    roomManagerTab: number;
    secretSantaTab: number;
    timelineEvent: {
      id?: number;
      event?: EventRow;
      users?: GetUserById[];
      votes?: VoteByEventId[];
    } | null;
    set: (props: Partial<SelectedSlice["selected"]>) => void;
  };
}

const createSelectedSlice: StateCreator<SelectedSlice, [], [], SelectedSlice> = (set) => ({
  selected: {
    eventApps: null,
    eventId: null,
    moneyManagerTab: MONEY_MANAGER_TAB.setup,
    groupId: null,
    groupInviteLink: null,
    roomManagerTab: ROOM_MANAGER_TAB.setup,
    secretSantaTab: SECRET_SANTA_TAB["my-pair"],
    timelineEvent: null,
    set: (props) => set((state) => ({ selected: { ...state.selected, ...props } })),
  },
});

export default createSelectedSlice;
